import React from 'react'
import '../../../App.scss';
import Grid from "@material-ui/core/Grid";
import Button from "../../pageComponents/Settings/Free/Button";
import Store from "../../../assets/images/store.png";
import DiscountCodeHolder from "../../../assets/images/wood_dig_store.png";
import WoodiFrame from "../../../assets/images/woodi_framee.png";
import Tick from "../../../assets/images/tick.png";
import Exit from "../../../assets/images/exit.png";
import WoodenInput from "../Settings/Free/WoodenInput";
import axios from "axios";
import {offCode,buy} from "../../../Utility/Url";
import DialogContent from "@material-ui/core/DialogContent";
import CustomDialog from "./Dialog";
import Dialog from "@material-ui/core/Dialog";
import PicoLoader from "./PicoLoader";
import Polygon from "../Home/GiftHall/Polygon";
import pentagonCyan from "../../../assets/images/pentagonCyan.png";
import pentagonGreen from "../../../assets/images/pentagonGreen.png";
import pentagonLightRed from "../../../assets/images/pentagonLightRed.png";
import pentagonOrange from "../../../assets/images/pentagonOrange.png";
import pentagonPink from "../../../assets/images/pentagonPink.png";
import pentagonRoseGold from "../../../assets/images/pentagonRoseGold.png";
import pentagonYellow from "../../../assets/images/pentagonYellow.png";
import HorizontalDivider from "../Home/GiftHall/HorizontalDivider";
import {withRouter} from "react-router-dom";

class GifHallPolygonDetail extends React.Component{
    constructor(props) {
        super(props)
        this.state={

        }
    }
    render() {
        const bgConverter=(color)=>{
            switch (color) {
                case 'yellow':
                    return pentagonYellow
                case 'roseGold':
                    return pentagonRoseGold
            }
        }
        const {data}=this.props
        const normal={
            icon:data.normalImg,
            text:data.giftValue_normal,
            textColor:'#ffffff',
            locked:false,
            polygon:bgConverter('roseGold'),
            hasGlowBackground:false,
        }
        const vip={
            icon:data.vipImg,
            text:data.giftValue_vip,
            textColor:'yellow',
            polygon:bgConverter('yellow'),
            locked:true,
            hasGlowBackground:true,
        }
        const badge={
            conditionValue:data.conditionValue,
            background:data.background
        }
        const button={
            text:'کسب امتیاز',
            backgroundColor:'green',
            bottomFontSize:'15px',
            buttonTextColor:'#ffffff',
            borderRadius:'5px',
        }
        return (
            <Grid sm={12} xs={12} alignItems={"center"} container justify={"flex-end"}
                  className='polygon-detail-dialog'>
                <Grid container alignItems={"center"} justify={"center"} className='polygon-detail-dialog-inner'>
                        <Grid sm={12} xs={12} container alignItems={"center"} justify={"center"}
                            style={{
                                marginTop: '-40%'
                            }}>
                        <Grid sm={5} xs={5} container alignItems={"center"} justify={"center"}
                              style={{height: '200px', padding: '20px'}}
                        >
                            <Polygon data={normal}/>
                        </Grid>
                        <Grid sm={5} xs={5} container alignItems={"center"} justify={"center"}
                              style={{height: '200px', padding: '20px'}}
                        >
                            <Polygon data={vip}/>
                        </Grid>
                    </Grid>
                    <Grid sm={8} xs={8} container alignItems={"center"} justify={"center"}
                    >
                        <HorizontalDivider data={badge}/>
                    </Grid>
                    <Grid sm={8} xs={8} className='gift-hall-offer-outer-inner-textbox' style={
                        {
                            textAlign:'center',
                            marginTop:'30px'
                        }
                    }>
                        <p>
                            با کلیک بر روی کسب امایتز و بازی در لیگ ویژه میتونید با هر جواب درست یک امتیاز در تالار جایزه کسب کنید
                        </p>
                    </Grid>
                    <Grid container alignItems={"center"} justify={"center"} sm={4} xs={4} style={{
                        height:'60px'
                    }} className='clickable' onClick={()=>{
                        this.props.history.push('/league-start')
                    }}>
                        <Button data={button}/>
                    </Grid>
                </Grid>


            </Grid>
        )
    }
}
export default withRouter(GifHallPolygonDetail)